export const nlDigitalTransformation = {
  title: "Consultancy voor Digitale Transformatie",
  description: "Expertadvies om uw bedrijf te begeleiden bij digitale modernisering, verbeterde klantervaringen en innovatie strategieën.",
  subtitle: "Oplossingen voor Digitale Transformatie Consultancy",

  servicesTitle: "Onze Consultancy Expertise",
  servicesSubtitle: "Strategisch advies om uw bedrijfsvoering toekomstbestendig te maken",
  services: {
    strategy: {
      title: "Consultancy voor Digitale Strategie",
      description: "Ontwikkel op maat gemaakte digitale roadmaps afgestemd op uw bedrijfsdoelen.",
      technologies: ["Digitale Roadmapping", "Verandermanagement", "Innovatieadvies", "Business Modeling", "Digitale Volwassenheid"]
    },
    automation: {
      title: "Consultancy voor Automatisering",
      description: "Advies over het implementeren van intelligente automatiseringsoplossingen om processen te stroomlijnen.",
      technologies: ["RPA Consultancy", "Workflowoptimalisatie", "BPM Advies", "AI Automatiseringsstrategie", "ERP Integratie"]
    },
    cloud: {
      title: "Cloud Consultancy",
      description: "Strategisch advies over migratie en optimalisatie van uw infrastructuur met veilige cloudtechnologieën.",
      technologies: ["AWS Consultancy", "Azure Advies", "Cloudstrategie", "Hybride Cloudoplossingen", "Cloudbeveiliging"]
    },
    data: {
      title: "Data & Analytics Consultancy",
      description: "Expertise in het benutten van uw data met geavanceerde analytics en business intelligence oplossingen.",
      technologies: ["Big Data Strategie", "BI Consultancy", "Data Governance", "Predictive Analytics", "Datavisualisatie"]
    },
    iot: {
      title: "IoT Consultancy",
      description: "Strategisch advies over het verbinden van fysieke assets met digitale systemen voor operationele inzichten.",
      technologies: ["IoT Strategie", "Implementatieadvies", "Edge Computing", "Industriële IoT", "IoT Platforms"]
    },
    ai: {
      title: "AI Consultancy",
      description: "Advies over het implementeren van intelligente systemen die zich aanpassen aan uw bedrijfsbehoeften.",
      technologies: ["AI Strategie", "ML Consultancy", "NLP Oplossingen", "Computer Vision", "AI Integratie"]
    }
  },

  processTitle: "Ons Consultancy Proces",
  processSteps: [
    {
      title: "Behoefteanalyse",
      description: "Uitgebreide evaluatie van uw huidige digitale capaciteiten en transformatie behoeften."
    },
    {
      title: "Strategieontwikkeling",
      description: "Ontwikkel op maat gemaakte digitale transformatiestrategieën voor uw specifieke bedrijfsuitdagingen."
    },
    {
      title: "Oplossingsadvies",
      description: "Adviseer over optimale technologieën en implementatiebenaderingen."
    },
    {
      title: "Verandermanagement",
      description: "Ontwikkel plannen om uw organisatie door digitale adoptie te leiden."
    },
    {
      title: "Implementatieondersteuning",
      description: "Bied deskundige begeleiding tijdens de technologie-implementatie."
    },
    {
      title: "Continue Adviesverlening",
      description: "Voortdurend advies om uw digitale capaciteiten te ontwikkelen."
    }
  ]
};

export const deDigitalTransformation = {
  title: "Beratung zur Digitalen Transformation",
  description: "Expertenberatung, um Ihr Unternehmen durch digitale Modernisierung, verbesserte Kundenerfahrungen und Innovationsstrategien zu führen.",
  subtitle: "Lösungen für Beratung zur Digitalen Transformation",

  servicesTitle: "Unsere Beratungsexpertise",
  servicesSubtitle: "Strategische Beratung zur Zukunftssicherung Ihrer Geschäftsprozesse",
  services: {
    strategy: {
      title: "Beratung für Digitale Strategie",
      description: "Entwicklung maßgeschneiderter digitaler Roadmaps, abgestimmt auf Ihre Geschäftsziele.",
      technologies: ["Digitale Roadmaps", "Change Management", "Innovationsberatung", "Geschäftsmodellierung", "Digitale Reife"]
    },
    automation: {
      title: "Automatisierungsberatung",
      description: "Fachkundige Beratung zur Implementierung intelligenter Automatisierungslösungen zur Prozessoptimierung.",
      technologies: ["RPA Beratung", "Workflow-Optimierung", "BPM Beratung", "KI-Automatisierungsstrategie", "ERP-Integration"]
    },
    cloud: {
      title: "Cloud Beratung",
      description: "Strategische Beratung zur Migration und Optimierung Ihrer Infrastruktur mit sicheren Cloud-Technologien.",
      technologies: ["AWS Beratung", "Azure Beratung", "Cloud-Strategie", "Hybride Cloud-Lösungen", "Cloud-Sicherheit"]
    },
    data: {
      title: "Daten- & Analytics-Beratung",
      description: "Expertise in der Nutzung Ihrer Daten mit fortschrittlichen Analytics- und Business-Intelligence-Lösungen.",
      technologies: ["Big Data Strategie", "BI Beratung", "Daten-Governance", "Predictive Analytics", "Datenvisualisierung"]
    },
    iot: {
      title: "IoT Beratung",
      description: "Strategische Beratung zur Verbindung physischer Assets mit digitalen Systemen für operative Einblicke.",
      technologies: ["IoT Strategie", "Implementierungsberatung", "Edge Computing", "Industrielles IoT", "IoT Plattformen"]
    },
    ai: {
      title: "KI Beratung",
      description: "Fachkundige Beratung zur Implementierung intelligenter Systeme, die sich an Ihre Geschäftsanforderungen anpassen.",
      technologies: ["KI Strategie", "ML Beratung", "NLP Lösungen", "Computer Vision", "KI Integration"]
    }
  },

  processTitle: "Unser Beratungsprozess",
  processSteps: [
    {
      title: "Bedarfsanalyse",
      description: "Umfassende Bewertung Ihrer aktuellen digitalen Fähigkeiten und Transformationsanforderungen."
    },
    {
      title: "Strategieentwicklung",
      description: "Entwicklung maßgeschneiderter Strategien für die digitale Transformation Ihrer spezifischen Geschäftsherausforderungen."
    },
    {
      title: "Lösungsberatung",
      description: "Empfehlung optimaler Technologien und Implementierungsansätze."
    },
    {
      title: "Change Management",
      description: "Entwicklung von Plänen zur Führung Ihrer Organisation durch die digitale Einführung."
    },
    {
      title: "Implementierungsunterstützung",
      description: "Fachkundige Beratung während der Technologieeinführung."
    },
    {
      title: "Kontinuierliche Beratung",
      description: "Laufende Beratung zur Weiterentwicklung Ihrer digitalen Fähigkeiten."
    }
  ]
};
export const enDigitalTransformation = {
  // Hero Section
  title: "Digital Transformation Consulting",
  description: "Expert consulting services to guide your business through comprehensive digital modernization, enhanced customer experiences, and innovation strategies.",
  subtitle: "Digital Transformation Consulting Solutions",

  // Services Section
  servicesTitle: "Our Consulting Expertise",
  servicesSubtitle: "Strategic guidance to future-proof your business operations",
  services: {
    strategy: {
      title: "Digital Strategy Consulting",
      description: "Develop customized digital roadmaps aligned with your business objectives and transformation goals.",
      technologies: ["Digital Roadmapping", "Change Management", "Innovation Advisory", "Business Modeling", "Digital Maturity"]
    },
    automation: {
      title: "Automation Consulting",
      description: "Expert guidance on implementing intelligent automation solutions to streamline operations.",
      technologies: ["RPA Consulting", "Workflow Optimization", "BPM Advisory", "AI Automation Strategy", "ERP Integration"]
    },
    cloud: {
      title: "Cloud Consulting",
      description: "Strategic advice on migrating and optimizing your infrastructure with secure cloud technologies.",
      technologies: ["AWS Consulting", "Azure Advisory", "Cloud Strategy", "Hybrid Cloud Solutions", "Cloud Security"]
    },
    data: {
      title: "Data & Analytics Consulting",
      description: "Expertise in harnessing your data with advanced analytics and business intelligence solutions.",
      technologies: ["Big Data Strategy", "BI Consulting", "Data Governance", "Predictive Analytics", "Data Visualization"]
    },
    iot: {
      title: "IoT Consulting",
      description: "Strategic guidance on connecting physical assets to digital systems for operational insights.",
      technologies: ["IoT Strategy", "Implementation Advisory", "Edge Computing", "Industrial IoT", "IoT Platforms"]
    },
    ai: {
      title: "AI Consulting",
      description: "Expert advice on implementing intelligent systems that adapt to your business needs.",
      technologies: ["AI Strategy", "ML Consulting", "NLP Solutions", "Computer Vision", "AI Integration"]
    }
  },

  // Process Section
  processTitle: "Our Consulting Process",
  processSteps: [
    {
      title: "Needs Assessment",
      description: "Comprehensive evaluation of your current digital capabilities and transformation requirements."
    },
    {
      title: "Strategy Development",
      description: "Create tailored digital transformation strategies for your specific business challenges."
    },
    {
      title: "Solution Advisory",
      description: "Recommend optimal technologies and implementation approaches."
    },
    {
      title: "Change Management",
      description: "Develop plans to guide your organization through digital adoption."
    },
    {
      title: "Implementation Support",
      description: "Provide expert guidance during technology deployment."
    },
    {
      title: "Continuous Advisory",
      description: "Ongoing consulting to evolve your digital capabilities."
    }
  ]
};

export const frDigitalTransformation = {
  title: "Consultation en Transformation Numérique",
  description: "Services de consultation d'experts pour guider votre entreprise à travers une modernisation numérique complète, des expériences client améliorées et des stratégies d'innovation.",
  subtitle: "Solutions de Consultation en Transformation Numérique",

  servicesTitle: "Notre Expertise en Consultation",
  servicesSubtitle: "Conseils stratégiques pour préparer votre entreprise aux opérations futures",
  services: {
    strategy: {
      title: "Consultation en Stratégie Numérique",
      description: "Développer des feuilles de route numériques personnalisées alignées sur vos objectifs commerciaux et vos objectifs de transformation.",
      technologies: ["Planification Numérique", "Gestion du Changement", "Conseil en Innovation", "Modélisation Commerciale", "Maturité Numérique"]
    },
    automation: {
      title: "Consultation en Automatisation",
      description: "Conseils d'experts sur la mise en œuvre de solutions d'automatisation intelligente pour rationaliser les opérations.",
      technologies: ["Consultation RPA", "Optimisation des Flux de Travail", "Conseil BPM", "Stratégie d'Automatisation IA", "Intégration ERP"]
    },
    cloud: {
      title: "Consultation en Cloud",
      description: "Conseils stratégiques sur la migration et l'optimisation de votre infrastructure avec des technologies cloud sécurisées.",
      technologies: ["Consultation AWS", "Conseil Azure", "Stratégie Cloud", "Solutions Cloud Hybrides", "Sécurité Cloud"]
    },
    data: {
      title: "Consultation en Données & Analytique",
      description: "Expertise dans l'exploitation de vos données avec des solutions d'analytique avancées et d'intelligence d'affaires.",
      technologies: ["Stratégie Big Data", "Consultation BI", "Gouvernance des Données", "Analytique Prédictive", "Visualisation des Données"]
    },
    iot: {
      title: "Consultation en IoT",
      description: "Conseils stratégiques sur la connexion des actifs physiques aux systèmes numériques pour des insights opérationnels.",
      technologies: ["Stratégie IoT", "Conseil en Mise en Œuvre", "Edge Computing", "IoT Industriel", "Plateformes IoT"]
    },
    ai: {
      title: "Consultation en IA",
      description: "Conseils d'experts sur la mise en œuvre de systèmes intelligents qui s'adaptent aux besoins de votre entreprise.",
      technologies: ["Stratégie IA", "Consultation ML", "Solutions NLP", "Vision par Ordinateur", "Intégration IA"]
    }
  },

  processTitle: "Notre Processus de Consultation",
  processSteps: [
    {
      title: "Évaluation des Besoins",
      description: "Évaluation complète de vos capacités numériques actuelles et de vos besoins en transformation."
    },
    {
      title: "Développement de Stratégie",
      description: "Créer des stratégies de transformation numérique sur mesure pour vos défis commerciaux spécifiques."
    },
    {
      title: "Conseil en Solutions",
      description: "Recommander des technologies optimales et des approches de mise en œuvre."
    },
    {
      title: "Gestion du Changement",
      description: "Développer des plans pour guider votre organisation à travers l'adoption numérique."
    },
    {
      title: "Support à la Mise en Œuvre",
      description: "Fournir des conseils d'experts lors du déploiement de technologies."
    },
    {
      title: "Conseil Continu",
      description: "Consultation continue pour faire évoluer vos capacités numériques."
    }
  ]
};